import React from 'react';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { getFormattedHrs } from '../../sitewide/components/locationMap/LocationMap';
import { LocationTypes } from '../../sitewide';
import { FormattedHrs } from '../../sitewide/components/locationMap/components/FormattedHrs';
import { weakKey } from '../../../utilities/weakKey';

export const ContactUsOfficeAndGateHours = ({
  show,
  locationConfig,
  locationType,
}: ContactUsPageTypes.IFacilityHrs) => {
  const renderFacilityHours = (
    formattedHrs: LocationTypes.TFormattedFacilityHours
  ) => {
    return (
      <React.Fragment key={weakKey(formattedHrs.officeHrs)}>
        {formattedHrs.officeHrs && (
          <div className="hoursParentContainer">
            <FormattedHrs
              show="facilityHrsOnly"
              formattedHrs={formattedHrs}
              onFacilityHrsToggle={() => void 0}
              size={32}
            />
          </div>
        )}
        {formattedHrs.gateHrs && (
          <div className="hoursParentContainer">
            <FormattedHrs
              show="gateHrsOnly"
              formattedHrs={formattedHrs}
              onFacilityHrsToggle={() => void 0}
              size={32}
            />
          </div>
        )}
      </React.Fragment>
    );
  };
  const getSingleLocationFacilityHrs = () => {
    return (
      <>
        {locationConfig.locations
          .slice(0, 1)
          .map((location: LocationTypes.TLocation) => {
            const formattedHrs = getFormattedHrs(location);
            return renderFacilityHours(formattedHrs);
          })}
      </>
    );
  };
  const getMultiLocationFacilityHrs = () => {
    return (
      <>
        {locationConfig.locations
          .slice(0, 1)
          .map((location: LocationTypes.TLocation) => {
            const formattedHrs = getFormattedHrs(location);
            return renderFacilityHours(formattedHrs);
          })}
      </>
    );
  };
  const getFacilityHours = (locationType: ContactUsPageTypes.TLocationType) => {
    switch (locationType) {
      case 'multi':
        return getMultiLocationFacilityHrs();
      default:
        return getSingleLocationFacilityHrs();
    }
  };

  return <>{show ? getFacilityHours(locationType) : <></>}</>;
};
